import axios from "axios";
import { IPaginationWrapper } from "../models/common";

export const getChangeLogItems = async (page: number, query: string) => {
    const res = await axios.get("/api/changeLog", { params: { page: page, query: query } });
    return res.data as IPaginationWrapper;
};

export const getChangeLogICSItems = async (page: number, query: string, language: string) => {
    const res = await axios.get("/api/changeLog/IcsLogs", {
        params: { page: page, query: query, language: language },
    });
    return res.data as IPaginationWrapper;
};

export const exportChangeLogItems = async () => {
    const res = await axios.get("/api/changeLog/download", { responseType: "blob" });
    const url = window.URL.createObjectURL(new Blob([res.data], { type: "text/csv" }));
    const link = document.createElement("a");
    link.href = url;
    const d = new Date();
    const date = new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, -1);
    const fileName = "NCDB_change_log_" + date + ".csv";
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.parentNode!.removeChild(link);
};
